/* eslint-disable import/prefer-default-export */

import axios from 'axios';
import { clone } from '@/utils/object';
import handler from './error-handler';

const client = axios.create({
  baseURL: `${process.env.VUE_APP_URL_API}/checkout/internal-register`
});
client.interceptors.response.use(
  response => Promise.resolve(response.data),
  e => handler(e)
);

export const getProgramParameters = programId => {
  return client.get(programId);
};

export const doRegister = (programId, data) => {
  const body = clone(data);

  body.document_number = data.document_number.replace(/\D/g, '');
  body.mobile = data.mobile.replace(/\D/g, '');
  body.address.zipcode = data.address.zipcode.replace(/\D/g, '');

  return client.post(`${programId}/register`, body);
};
